import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { io, Socket } from 'socket.io-client';

import { environment } from 'src/environments/environments';

/**
 * Keeps one persistent socket.io connection open for the lifetime of an
 * authenticated admin session. The backend derives this admin's
 * online/offline presence from whether this connection is alive, then
 * broadcasts `admin:presence:changed` to superadmin dashboards — this side
 * never emits or listens for anything, it only needs to stay connected.
 */
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket | null = null;

  constructor(private router: Router) { }

  connect(token: string): void {
    if (!token) {
      return;
    }

    if (this.socket) {
      if (this.socket.connected && (this.socket.auth as any)?.token === token) {
        return;
      }
      this.disconnect();
    }

    this.socket = io(environment.socketUrl, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true
    });

    this.socket.on('connect_error', (err: Error) => {
      console.error('Socket connect_error:', err.message);
      if (err.message === 'No token' || err.message === 'Invalid token') {
        this.disconnect();
        this.router.navigate(['/login']);
      }
    });

    this.socket.io.on('reconnect', () => {
      console.log('Socket reconnected');
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
